import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterHomeLayoutShell = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("home/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.LayoutShell />,
        });
      })
      .catch(reject);
  });
});

export const LazyHomeLayoutShell = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterHomeLayoutShell />
    </Suspense>
  );
};
